import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import Venue from "@/components/landing/Venue";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Availability from "@/components/landing/Availability";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-ebony font-sans text-cream antialiased">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Venue />
        <About />
        <Services />
        <Availability />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            border: "1px solid rgba(197,160,89,0.35)",
            color: "#F5F2EB",
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
